import 'requestidlecallback-polyfill'

const FEATURES = [
  {
    test: () => 'assSettled' in Promise && typeof Promise.allSettled === 'function',
    importStatement: () =>
      import(/* webpackChunkName: "promise-allSettled" */ 'core-js/modules/es.promise.all-settled'),
  },
  {
    test: () => 'replaceAll' in String.prototype && typeof String.prototype.replaceAll === 'function',
    importStatement: () =>
      import(/* webpackChunkName: "string-prototype-replaceAll" */ 'core-js/modules/es.string.replace-all'),
  },
  {
    test: () => 'padStart' in String.prototype && typeof String.prototype.padStart === 'function',
    importStatement: () =>
      import(/* webpackChunkName: "string-prototype-padStart" */ 'core-js/modules/es.string.pad-start'),
  },
  {
    test: () => 'at' in Array.prototype && typeof Array.prototype.at === 'function',
    importStatement: () =>
      import(/* webpackChunkName: "array-prototype-at" */ 'core-js/modules/es.array.at'),
  },
  {
    test: () => window && 'structuredClone' in window && typeof window.structuredClone === 'function',
    importStatement: () =>
      import(/* webpackChunkName: "web-structured-clone" */ 'core-js/modules/web.structured-clone'),
  }
] as const

/**
 * Применяет необходимые полифилы для приложения на основе проверки функций.
 * Проверяет доступность функций и динамически импортирует полифилы
 * для отсутствующих функций. Если все необходимые функции поддерживаются,
 * полифилы не загружаются.
 *
 * @return {Promise<unknown>} Промис, который разрешается после успешной загрузки
 * всех необходимых полифилов или отклоняется при ошибке во время процесса
 * загрузки.
 */
export function applyPolyfills () : Promise<unknown> {
  const polyfills: Promise<unknown>[] = []

  for (const feature of FEATURES) {
    if (feature.test()) {
      continue
    }

    polyfills.push(feature.importStatement())
  }

  return Promise.all(polyfills).catch(error => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[polyfill] Missing or broken feature, loading: ${error.message}`)
    }
  })
}
